import { GetterTree } from 'vuex';

import { RootState } from '@/store';
import {
  ESTADO_TURMA,
  TrabalhoSituacaoFinalModel,
} from '@/services/academico/situacaofinal/situacao-final.service';
import { State } from './state';

export type Getters = {
  getAcompanhamentoAta(state: State): TrabalhoSituacaoFinalModel | null;
  getAcompanhamentoAtaVisivel(state: State): boolean;
  getAcompanhamentoAtaRecolhida(state: State): boolean;
  getAcompanhamentoAtaTitulo(state: State): string;
  getAcompanhamentoAtaErro(state: State): string;
  getAcompanhamentoAtaFiltros(state: State): string | null;
  getAcompanhamentoAtaCodigoRelatorio(state: State): string;
  getAcompanhamentoAtaCodigoEscola(state: State): number;
  getAcompanhamentoAtaAno(state: State): number;
  getAcompanhamentoAtaSemestre(state: State): number;
  getAcompanhamentoAtaTerminou(state: State): boolean;
  getAcompanhamentoAtaPercentual(state: State): number;
  getAcompanhamentoAtaTurmasCalculadas(state: State): number[];
};

export const getters: GetterTree<State, RootState> & Getters = {
  getAcompanhamentoAta: (state) => state.trabalho,
  getAcompanhamentoAtaVisivel: (state) => state.visivel && Boolean(state.idTrabalho),
  getAcompanhamentoAtaRecolhida: (state) => state.recolhida,
  getAcompanhamentoAtaTitulo: (state) => state.titulo,
  getAcompanhamentoAtaErro: (state) => state.erro,
  getAcompanhamentoAtaFiltros: (state) => state.filtrosRelatorio,
  getAcompanhamentoAtaCodigoRelatorio: (state) => state.codigoRelatorio,
  getAcompanhamentoAtaCodigoEscola: (state) => state.codigoEscola,
  getAcompanhamentoAtaAno: (state) => state.ano,
  getAcompanhamentoAtaSemestre: (state) => state.semestre,

  /**
   * O cálculo acabou? Erro no acompanhamento também conta: sem como saber do andamento, a emissão
   * é liberada com o que estiver gravado — melhor do que deixar o usuário travado.
   */
  getAcompanhamentoAtaTerminou: (state) =>
    Boolean(state.trabalho?.terminou) || Boolean(state.erro),

  getAcompanhamentoAtaPercentual: (state) => {
    const trabalho = state.trabalho;

    if (!trabalho || trabalho.total === 0) return 0;

    return Math.round((trabalho.concluidas / trabalho.total) * 100);
  },

  /**
   * As turmas que já não precisam de recálculo.
   *
   * A ignorada entra junto: ela não tinha o que recalcular (turma fechada, sem matrícula, sem
   * grade), e segurar a impressão por causa dela seria pedir um cálculo que nunca vai acontecer. A
   * que deu erro fica de fora — essa precisa ser tentada de novo.
   */
  getAcompanhamentoAtaTurmasCalculadas: (state) =>
    (state.trabalho?.turmas ?? [])
      .filter(
        (turma) =>
          turma.estado === ESTADO_TURMA.calculada || turma.estado === ESTADO_TURMA.ignorada,
      )
      .map((turma) => turma.codigoTurma),
};
